import { FormConfig, Notice, Text } from '@lbcamden/lib-react';
import { DateTime } from 'luxon';
import { z } from 'zod';

import { ClientGlobalStore } from '~/client/store/tinybase/ClientGlobalStore';
import { pcfraDetailsSchema, residentRepresentativeSchema } from '~/common/schemas/pcfra';
import { contactDetailsFormSchema } from '~/common/schemas/people';
import { ResidentRepresentative } from '~/common/types/pcfra';

import { contactDetailsFormConfig } from '../../../PersonPage/ContactDetailsEditPage/config';
import { getChildFormRenderFn, getConditionalChildFormRenderFn } from '../../form/helpers';
import { FieldHeading } from '../common.styled';

export type DetailsFormValues = z.infer<typeof pcfraDetailsSchema>;

export const detailsFormConfig = (
  referenceListSelectOptions: ClientGlobalStore['referenceListSelectOptions'],
): FormConfig<DetailsFormValues> => ({
  fieldConfigs: {
    pcfraReference: {
      label: 'PCFRA reference',
      readOnly: true,
    },
    createdBy: {
      readOnly: true,
    },
    uprn: {
      label: 'UPRN',
      readOnly: true,
    },
    floorLevel: {
      label: (
        <>
          <Text css={(theme) => ({ marginBottom: theme.spacing(4) })}>Property floor level *</Text>
          <Notice infoWithIcon>
            Updating this field will update the stored value for the property
          </Notice>
        </>
      ),
      hideRequiredIndicator: true,
      autocomplete: true,
      selectOptions: referenceListSelectOptions('FLOORLEVEL'),
    },
    contactDetails: {
      label: (
        <>
          <FieldHeading>Resident contact details</FieldHeading>
          <Notice infoWithIcon>
            Updating these values will update the stored contact details for the resident
          </Notice>
        </>
      ),
      customRenderFn: getChildFormRenderFn({
        schema: contactDetailsFormSchema,
        config: contactDetailsFormConfig,
      }),
      hideFieldErrorMessage: true,
      hideRequiredIndicator: true,
    },
    residentRepresentative: {
      label: (
        <>
          <FieldHeading>{`Resident's representative`}</FieldHeading>
          <Text>
            Does the resident have a representative that should be contacted on their behalf? *
          </Text>
        </>
      ),
      customRenderFn: getConditionalChildFormRenderFn<ResidentRepresentative>({
        schema: residentRepresentativeSchema,
      }),
      hideRequiredIndicator: true,
    },
    referrerEmailAddress: {
      placeholder: '@camden.gov.uk',
    },
    dateOfVisit: {
      type: 'date',
      inputProps: { max: DateTime.now().toISODate() },
    },
  },
});
